import Choices from 'choices.js';

/**
 * Initialize searchable city select using Choices.js
 */
class CitySelect {
  private defaultOptions = {
    searchEnabled: true,
    itemSelectText: '',
    classNames: {
      containerOuter: 'choices',
      containerInner: 'choices-inner',
    },
    placeholder: true,
  };

  constructor(
    private containerSelector: string = '.js-city-select',
    private options = {},
  ) {
    this.options = { ...this.defaultOptions, ...options };
    this.init();
  }

  private init(): void {
    document.addEventListener('DOMContentLoaded', () => {
      const selects = document.querySelectorAll<HTMLSelectElement>(
        this.containerSelector,
      );
      if (selects.length > 0) {
        selects.forEach((element) => {
          const searchPlaceholder = element.dataset.searchPlaceholder || '';
          const noResults = element.dataset.noResults || '';

          new Choices(element, {
            ...this.options,
            searchPlaceholderValue: searchPlaceholder,
            noResultsText: noResults,
            shouldSort: false,
          });
        });
      }
    });
  }
}

export default CitySelect;
